
import React from 'react';
import { Container } from 'lucide-react';

const TechLogoBanner = () => {
  // Define logos with their sources and alt text
  const logos = [
    { src: "https://supabase.com/favicon/favicon-32x32.png", alt: "Supabase" },
    { icon: Container, alt: "Docker" }, // Using Container icon as a visual replacement for Docker
    { src: "https://n8n.io/favicon.ico", alt: "n8n" },
    { src: "https://flowiseai.com/favicon.ico", alt: "Flowise AI" },
    { src: "https://resend.com/favicon.ico", alt: "Resend.com" },
    { src: "https://cloudflare.com/favicon.ico", alt: "Cloudflare" },
    { src: "https://openai.com/favicon.ico", alt: "OpenAI" },
    { src: "https://claude.ai/favicon.ico", alt: "Claude AI" },
    { src: "https://groq.com/favicon.ico", alt: "Groq" },
    { src: "https://openrouter.ai/favicon.ico", alt: "Open Router" },
    { src: "https://deepinfra.com/favicon.ico", alt: "DeepInfra" },
    { src: "https://www.nvidia.com/favicon.ico", alt: "NVIDIA NIM" },
    { src: "https://ubuntu.com/favicon.ico", alt: "Ubuntu" },
    { src: "https://raw.githubusercontent.com/ollama/ollama/main/docs/ollama.png", alt: "Ollama" }, // Updated Ollama image URL
    { src: "https://huggingface.co/favicon.ico", alt: "Hugging Face" },
  ];

  return (
    <div className="w-full py-10 bg-white bg-opacity-30">
      <h3 className="text-2xl font-bold text-center mb-8 text-gray-800">Tech Stack</h3>
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6">
          {logos.map((logo, index) => (
            <div key={`logo-${index}`} className="flex items-center justify-center">
              {logo.icon ? (
                <logo.icon className="w-8 h-8 md:w-10 md:h-10 text-gray-600" />
              ) : (
                <img 
                  src={logo.src} 
                  alt={logo.alt} 
                  className="w-8 h-8 md:w-10 md:h-10 object-contain"
                  onError={(e) => {
                    console.error(`Failed to load logo: ${logo.alt}`);
                    e.currentTarget.style.display = 'none';
                  }}
                />
              )}
              <span className="sr-only">{logo.alt}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechLogoBanner;
